export default ($axios) => ({
  fetch(input) {
    return $axios.post('/admin/sms/insights', input).then((response) => response.data);
  },
});
